import React from 'react';
import './Footer.css';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
   const nav=useNavigate()
  const handleScroll = (id) => {
    nav(id)

  };

  return (
    <footer className="international-footer glass-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <h2>Kajja Galleries</h2>
          <p>Elevating Spaces with Interior Design & Custom Furniture</p>
        </div>

        <div className="footer-links">
          <h4>Explore</h4>
          <ul>
            <li onClick={() => handleScroll('/')}>Home</li>
            <li onClick={() => handleScroll('services')}>Services</li>
            <li onClick={() => handleScroll('portfolio')}>Portfolio</li>
            <li onClick={() => handleScroll('contact')}>Contact</li>
          </ul>
        </div>

        <div className="footer-newsletter">
          <h4>Subscribe to our Newsletter</h4>
          <form>
            <input type="email" placeholder="Your email address" />
            <button type="submit">Subscribe</button>
          </form>
        </div>

        <div className="footer-language">
          <h4>Language</h4>
          <select>
            <option value="en">English</option>
            <option value="sw">Swahili</option>
            <option value="fr">French</option>
          </select>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Kajja Galleries. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
